import React from 'react';
import { MailIcon, InstagramIcon } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-grape/15 bg-white/70" data-id="element-51" data-mp="3gezfnanhw34b">
      <div className="mx-auto max-w-4xl px-5 py-12 text-center" style={{
      paddingTop: "25px"
    }} data-id="element-52" data-mp="3ghc2o28413o8">
        <p className="font-display text-xl font-black text-plum" data-id="element-53" data-mp="32m1bayt2r0om">
          SIGMA SMART<span className="align-super text-xs" data-id="element-54" data-mp="36ppk1ktg02bg">™</span> — PROTOCOLLO ATLETA 360<span className="align-super text-xs" data-id="element-55" data-mp="3ug3etj3ewf9q">™</span>
        </p>

        <p className="mt-4 font-display text-base font-semibold italic text-grape" data-id="element-56" data-mp="38qyt7e9m7ve">
          🏥 “Il tuo primo protocollo inizia oggi.”
        </p>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-plum/75" data-id="element-57" data-mp="3ldkg9b6nsota">
          <a href="mailto:soporte.sigmasmart@gmail.com" className="inline-flex items-center gap-2 transition-colors duration-150 ease-out hover:text-grape" data-id="element-58" data-mp="3qblwlocpaa12">
            <MailIcon className="h-4 w-4 text-grape" data-id="element-59" data-mp="2eyjs3rnvlax9" /> soporte.sigmasmart@gmail.com
          </a>
          <a href="#" className="inline-flex items-center gap-2 transition-colors duration-150 ease-out hover:text-grape" data-id="element-60" data-mp="3l90ozzfy550u">
            <InstagramIcon className="h-4 w-4 text-grape" data-id="element-61" data-mp="3gbqz6ionarch" /> @sigmasmartitaliano
          </a>
        </div>

        <div className="mt-8 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-plum/45" data-id="element-62" data-mp="3v9b1tiy2kafh">
          <a href="#" className="transition-colors duration-150 ease-out hover:text-plum" data-id="element-63" data-mp="3q725cclzmq8m">
            Termini e condizioni
          </a>
          <span data-id="element-64" data-mp="33xdnwzdzwrz">·</span>
          <a href="#" className="transition-colors duration-150 ease-out hover:text-plum" data-id="element-65" data-mp="34gx5i4oqt84">
            Privacy Policy
          </a>
          <span data-id="element-66" data-mp="hriipwfto62j">·</span>
          <a href="#" className="transition-colors duration-150 ease-out hover:text-plum" data-id="element-67" data-mp="huwh6tld7v4p">
            Supporto
          </a>
        </div>

        <p className="mt-8 text-xs leading-relaxed text-plum/40" data-id="element-68" data-mp="qt05tyrnd80q">
          © 2026 SIGMA SMART™ — Tutti i diritti riservati.
        </p>
      </div>
    </footer>;
}